import React from 'react';
import {
  StyledSpecialOfferPriceButton,
  StyledSpecialOfferPrice,
} from './style';
import { ActualPrice } from 'components/BundlePrice/ActualPrice';
import { Prices } from 'utils/types';

interface IProductMadnessSpecialOfferPrice {
  prices: Prices;
  buttonTextColor: string;
  collectText?: string;
  isFree: boolean;
}

export const ProductMadnessSpecialOfferPrice: React.FC<
  IProductMadnessSpecialOfferPrice
> = ({ prices, buttonTextColor, isFree = false, collectText }) => {
  return (
    <StyledSpecialOfferPriceButton>
      <StyledSpecialOfferPrice buttonTextColor={buttonTextColor}>
        <div className={'decoration'} />
        <div className={'totalPrice'}>
          {isFree ? (
            <span>{collectText}</span>
          ) : (
            <ActualPrice prices={prices} textShadow="none" />
          )}
        </div>
      </StyledSpecialOfferPrice>
    </StyledSpecialOfferPriceButton>
  );
};
